import { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ address: '', phone: '' });
  const [members, setMembers] = useState({}); // { [clinicId]: { address, phone } }
  const [editingMember, setEditingMember] = useState(null);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const headers = { Authorization: 'Bearer ' + localStorage.getItem('clinicToken') };

  const load = () => axios.get(`${API}/clinic-cabinet/profile`, { headers }).then(r => {
    setProfile(r.data);
    if (r.data.target_type === 'clinic') {
      setForm({ address: r.data.address || '', phone: r.data.phone || '' });
    } else {
      setForm({ phone: r.data.phone || '' });
      const m = {};
      (r.data.members || []).forEach(x => { m[x.id] = { address: x.address || '', phone: x.phone || '' }; });
      setMembers(m);
    }
  });

  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async () => {
    setBusy(true); setErr(''); setMsg('');
    try {
      await axios.patch(`${API}/clinic-cabinet/profile`, form, { headers });
      setMsg('Сохранено'); load();
    } catch (e) { setErr(e?.response?.data?.detail || 'Не удалось сохранить'); }
    setBusy(false);
  };

  const saveMember = async (clinicId) => {
    setBusy(true); setErr(''); setMsg('');
    try {
      await axios.patch(`${API}/clinic-cabinet/profile/members/${clinicId}`, members[clinicId], { headers });
      setMsg('Учреждение обновлено'); setEditingMember(null); load();
    } catch (e) { setErr(e?.response?.data?.detail || 'Не удалось сохранить'); }
    setBusy(false);
  };

  if (!profile) return <Layout><div style={s.empty}>Загрузка…</div></Layout>;

  return (
    <Layout>
      <h1 style={s.h1}>Профиль</h1>

      <div style={s.card}>
        <div style={s.name}>{profile.name}</div>
        {profile.target_type === 'clinic' && (
          <>
            <label style={s.label}>Адрес</label>
            <input style={s.input} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="Город, улица, дом" />
          </>
        )}
        <label style={s.label}>Телефон</label>
        <input style={s.input} value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+7 ..." />
        {err && <div style={s.err}>{err}</div>}
        {msg && <div style={s.ok}>{msg}</div>}
        <div style={s.actions}>
          <button style={s.btn} onClick={save} disabled={busy}>{busy ? 'Сохранение…' : 'Сохранить'}</button>
        </div>
      </div>

      {profile.target_type === 'network' && (
        <>
          <h2 style={s.h2}>Учреждения сети</h2>
          <div style={s.tableCard}>
            {(profile.members || []).length === 0 && <div style={s.empty}>Учреждений пока нет</div>}
            {(profile.members || []).map(m => (
              <div key={m.id} style={s.row}>
                {editingMember === m.id ? (
                  <div style={s.memberEdit}>
                    <div style={s.memberName}>{m.name}</div>
                    <input style={s.input} value={members[m.id]?.address || ''}
                      onChange={e => setMembers({ ...members, [m.id]: { ...members[m.id], address: e.target.value } })}
                      placeholder="Адрес" />
                    <input style={s.input} value={members[m.id]?.phone || ''}
                      onChange={e => setMembers({ ...members, [m.id]: { ...members[m.id], phone: e.target.value } })}
                      placeholder="Телефон" />
                    <div style={s.actions}>
                      <button style={s.btnGhost} onClick={() => setEditingMember(null)}>Отмена</button>
                      <button style={s.btn} onClick={() => saveMember(m.id)} disabled={busy}>Сохранить</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div style={s.rowMain}>
                      <div style={s.memberName}>{m.name}</div>
                      <div style={s.rowMeta}>{m.address || 'адрес не указан'}{m.phone ? ` · ${m.phone}` : ''}</div>
                    </div>
                    <button style={s.btnGhostSm} onClick={() => setEditingMember(m.id)}>Изменить</button>
                  </>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </Layout>
  );
}

const s = {
  h1: { color: '#1B2B4B', fontSize: 28, fontWeight: 800, margin: '0 0 20px' },
  h2: { color: '#1B2B4B', fontSize: 18, fontWeight: 700, margin: '24px 0 12px' },
  name: { color: '#1B2B4B', fontSize: 16, fontWeight: 700, marginBottom: 8 },
  card: { background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 4px 16px rgba(27,43,75,0.06)', display: 'flex', flexDirection: 'column', gap: 6 },
  label: { color: '#64748b', fontSize: 13, fontWeight: 600, marginTop: 8 },
  input: { background: '#F6F8FB', border: '1px solid #d7dee8', borderRadius: 10, padding: '10px 14px', fontSize: 14, color: '#1B2B4B', outline: 'none' },
  err: { color: '#dc2626', fontSize: 13 },
  ok: { color: '#149e90', fontSize: 13 },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
  btn: { background: '#2EC4B6', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', border: '1px solid #d7dee8', color: '#64748b', borderRadius: 10, padding: '10px 20px', fontSize: 14, cursor: 'pointer' },
  btnGhostSm: { background: 'transparent', border: '1px solid #d7dee8', color: '#64748b', borderRadius: 8, padding: '6px 14px', fontSize: 13, cursor: 'pointer' },
  tableCard: { background: '#fff', borderRadius: 16, padding: '8px 8px', boxShadow: '0 4px 16px rgba(27,43,75,0.06)' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid #f4f7fb' },
  rowMain: { display: 'flex', flexDirection: 'column', gap: 4 },
  rowMeta: { color: '#94a3b8', fontSize: 13 },
  memberName: { color: '#1B2B4B', fontWeight: 600, fontSize: 15 },
  memberEdit: { display: 'flex', flexDirection: 'column', gap: 8, width: '100%' },
  empty: { color: '#94a3b8', textAlign: 'center', padding: '32px 0', fontSize: 14 },
};
